import {Component, OnInit, OnDestroy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {TermsService} from '../../services/terms.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-accept-terms-eu',
  templateUrl: './accept-terms-eu.component.html',
  styleUrls: ['./accept-terms-eu.component.scss']
})
export class AcceptTermsEuComponent implements OnInit, OnDestroy {
  termsText: string;
  private langSub: Subscription;

  constructor(
    private dialogRef: MatDialogRef<AcceptTermsEuComponent>,
    private termsService: TermsService,
    private translate: TranslateService
  ) {
    this.termsText = this.termsService.getTermsTextEuStandard();
  }

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.termsText = this.termsService.getTermsTextEuStandard();
    });
  }

  approve() {
    this.dialogRef.close({approve: true});
  }

  close() {
    this.dialogRef.close({approve: false});
  }

  ngOnDestroy(): void {
    if (this.langSub) { this.langSub.unsubscribe(); }
  }
}
